import type { SVGProps } from 'react'

type Props = Omit<SVGProps<SVGSVGElement>, 'className'> & { className?: string }

const FilterIcon = ({ className, ...props }: Props) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <path
            d="M5 5V8L10.5 12.8846V19.5L14.5 18.2308V12.8846L20 8V5H5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default FilterIcon
